import { BaseService } from '../../infra/base.service'
import { Store } from '../../infra/store.service'
import { UserPermissions } from './dto/user-permissions.dto'
import type { User } from './user'
import type { UserNotifications } from './user-notification'
import type { UsersRepository } from './users.repository'

export class UsersService extends BaseService<User> {
    private store: Store
    constructor(private usersRep: UsersRepository) {
        super(usersRep)
        this.store = new Store()
    }

    async updatePermissions(userId: string, dto: UserPermissions) {
        return await this.usersRep.updatePermissions(userId, dto)
    }

    async getPermissions(userId: string): Promise<UserPermissions> {
        return await this.usersRep.getPermissions(userId)
    }

    async updateInfoFromLoggedUser(userUpdateDto: Partial<User>) {
        return await this.usersRep.update(this.store.token.userId, userUpdateDto)
    }

    async upsertFCMToken(token: string) {
        return await this.usersRep.upsertFCMToken(token)
    }

    async upsertNotifications(dto: UserNotifications) {
        return await this.usersRep.upsertNotifications(dto)
    }

    async getManager() {
        return await this.usersRep.getManager()
    }
}
